<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="publication-result">
    <component
      :is="url ? 'a' : 'div'"
      :href="url">
      <img :src="src"
           :srcset="srcSet"
           :alt="`Cover image for ${name}`"
           class="publication-result__image">

      <span
        v-if="isComingSoon"
        class="flash flash--coming-soon publication-result__flash">
        Coming soon
      </span>

      <span
        v-else-if="isNew"
        class="flash flash--new publication-result__flash">
        New
      </span>
    </component>

    <div class="publication-result__content">
      <ul v-if="hasAges || hasCategories || hasFormats"
          class="publication-result__tags">
        <template v-if="hasAges">
          <li v-for="(age, index) in ages"
              :key="index"
              class="publication-result__tag">
            <age-tag :value="age"></age-tag>
          </li>
        </template>

        <template v-if="hasFormats">
          <li v-for="(format, index) in formats"
              :key="index"
              class="publication-result__tag">
            <format-tag :value="format"></format-tag>
          </li>
        </template>

        <template v-if="hasCategories">
          <li v-for="(category, index) in categories"
              :key="index"
              class="publication-result__tag">
            <category-tag :value="category"></category-tag>
          </li>
        </template>
      </ul>

      <a class="publication-result__link"
         :href="url">
        <h3 class="publication-result__name">
          {{ name }}
        </h3>
      </a>

      <span v-if="showPrice"
            class="publication-result__price">
        {{ renderPrice( price ) }}
      </span>

      <div class="publication-result__footer">
        <add-to-basket v-if="showQuickAdd"
                       :product-id="productId"
                       class="btn btn-accent-3 publication-result__btn">
          <font-awesome-icon :icon="['far', 'shopping-basket']"></font-awesome-icon>
          Add to Basket
        </add-to-basket>

        <div class="publication-result__formats">
          <span v-if="!isDigital"
                class="round-icon">
            <font-awesome-icon icon="book"
                               title="Print"></font-awesome-icon>
          </span>

          <span v-else
                class="round-icon">
            <font-awesome-icon icon="download"
                               title="Digital"></font-awesome-icon>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EcommerceModule } from "spiritweb.packages.ecommerce";

export default {
  name: "PublicationSearchResult",
  props: {
    url: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: "",
    },
    searchThumbnail: {
      type: String,
      default: null,
    },
    thumbnailAltText: {
      type: String,
      default: undefined,
    },
    hasWebPage: {
      type: Boolean,
      default: false,
    },
    price: {
      type: Number,
      default: 0,
    },
    showPrice: {
      type: Boolean,
      default: false,
    },
    isNew: {
      type: Boolean,
      default: false,
    },
    isComingSoon: {
      type: Boolean,
      default: false,
    },
    productId: {
      type: Number,
      default: null,
    },
    showQuickAdd: {
      type: Boolean,
      default: false,
    },
    ages: {
      type: Object,
      default: () => {},
    },
    categories: {
      type: Object,
      default: () => {},
    },
    formats: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    hasAges () {
      let result = false;

      if ( this.ages && Object.keys( this.ages ).length > 0 ) {
        result = true;
      }

      return result;
    },
    hasCategories () {
      let result = false;

      if ( this.categories && Object.keys( this.categories ).length > 0 ) {
        result = true;
      }

      return result;
    },
    hasFormats () {
      let result = false;

      if ( this.formats && Object.keys( this.formats ).length > 0 ) {
        result = true;
      }

      return result;
    },
    isDigital () {
      let result = false;

      if ( this.formats ) {
        result = Object.values( this.formats )?.some( x => x === "Download" );
      }

      return result;
    },
    src () {
      return this.generateUrl( 566 );
    },
    srcSet () {
      return `${this.generateUrl( 566 )} 1x, ${this.generateUrl( 932 )} 2x`;
    },
  },
  methods: {
    renderPrice ( price ) {
      return EcommerceModule.renderPrice( price, "gbp", "en-gb" );
    },
    generateUrl ( height ) {
      let result = `/Assets/images/image-placeholder.png?height=${height}`;

      if ( this.searchThumbnail ) {
        if ( !this.searchThumbnail.startsWith( "/" ) ) {
          let url = `${this.searchThumbnail}`;
          url = this.removeDuplicateQueryParam( url, { height } );
          result = `/remote.axd?${url}`;
        } else {
          const trimmedUrl = this.searchThumbnail.replace( "/remote.axd?", "" );
          result = `/remote.axd?${this.removeDuplicateQueryParam( `${trimmedUrl}`, { height } )}`;
        }
      }
      return `${encodeURI( result )}`;
    },
    removeDuplicateQueryParam ( url, queryParams ) {
      let fullUrl;
      if ( url.startsWith( "/" ) ) {
        fullUrl = new URL( url, window.location.origin );
      } else {
        fullUrl = new URL( url );
      }
      const uniqueQueryParams = { ...queryParams };
      fullUrl.searchParams.forEach( ( value, key ) => {
        if ( !uniqueQueryParams[key] ) {
          uniqueQueryParams[key] = value;
        }
      } );
      fullUrl.search = "";
      Object.keys( uniqueQueryParams ).forEach( key => {
        fullUrl.searchParams.set( key, uniqueQueryParams[key] );
      } );
      if ( url.startsWith( "/" ) ) {
        fullUrl = fullUrl.href.substring( window.location.origin.length );
      }
      return fullUrl;
    },
  },
};
</script>
